import { Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CvxProfileComponent } from '../cvx-profile/cvx-profile.component';

@Component({
    selector: 'app-cvx-header',
    standalone: true,
    imports: [MatButtonModule, CvxProfileComponent],
    templateUrl: './cvx-header.component.html',
    styleUrl: './cvx-header.component.scss'
})
export class CvxHeaderComponent {

    applicationTitle = input.required<string>();    
    btnToggle = output<void>();

    btnLeftMenuClick(event: Event) {
       this.btnToggle.emit();
    }
}
